module.exports = __webpack_public_path__ + "img/bg.4c8a24fa.jpg";